import { useFitFinishFrameSections } from '../../../hooks/exterior/useFitFinishFrameSections';
import { useLevel2ExteriorSections } from '../../../hooks/exterior/useLevel2ExteriorSections';
import { useTireSections } from '../../../hooks/exterior/useTireSections';
import { useLevel2InteriorSections } from '../../../hooks/interior/useLevel2InteriorSections';
import { GradeUIBar } from './GradeUIBar';
import { useParsedGrades } from './useParsedGrades';

export const InteriorGrades = () => {
  const interiorSections = useLevel2InteriorSections();

  const grades = useParsedGrades(interiorSections);
  return <GradeUIBar gradePercents={grades} />;
};
